const ajax = {};

let url = "https://api.everviz.com";

let token = false;
let team = false;

const responseToErrorJson = (r) => {
  let response = r.responseText;

  try {
    response = JSON.parse(response);
  } catch (e) {
    // eslint-disable no-empty
    // Simply return response as-is
  }

  return {
    status: r.status,
    response: response,
    toString: () => {
      return r.status + ': ' + r.responseText;
    }
  };
};

ajax.ajax = (props, skip) => {
  let properties = Object.assign({
    url: false,
    type: 'get'
  }, props);
  return new Promise((resolve, reject) => {
    let r = new XMLHttpRequest();
    if (!properties.url) {
      return reject('no url specified');
    }
    if (skip) r.open(properties.type, properties.url, true);
    else r.open(properties.type, url + properties.url, true);

    if (token) {
      r.setRequestHeader('X-CMS-Key', token);
    }

    if (properties.headers) {
      Object.keys(properties.headers).forEach((key) => {
        r.setRequestHeader(key, properties.headers[key]);
      });
    }

    r.onreadystatechange = () => {
      if (r.readyState === 4) {
        let json = false;

        if (r.status === 200) {
          try {
            json = JSON.parse(r.responseText);
          } catch (e) {
            return reject({
              status: 200,
              message: 'unexpected return: ' + e
            });
          }

          if (json.error) {
            return reject({
              status: 200,
              message: json.message
            });
          }
          return resolve(json);
        }

        try {
          json = JSON.parse(r.responseText);
        } catch (e) {
          return reject(responseToErrorJson(r));
        }

        return reject(responseToErrorJson(r));
      }
    };

    if (properties.data) {
      try {
        properties.data = JSON.stringify(properties.data);
      } catch (e) {
        // Do nothing
      }
    }
    r.send(properties.data);

  });
};

ajax.verifyLicense = (everviz_license) => {
 
  return ajax.ajax({
    url: '/account/license',
    type: 'post',
    headers: {
      'Content-Type': "application/json"
    },
    data: {
      license_key: everviz_license
    }
  })
  .then((result) => {
    token = everviz_license;
    team = result.team_id;
    return result;
  });
};

ajax.registerUser = (email, password) => {

  return ajax.ajax({
    url: '/account',
    type: 'post',
    headers: {
      'Content-Type': "application/json"
    },
    data: {
      email: email,
      password: password,
      cms: true
    }
  })
  .then((result) => {
    return result;
  });
}

ajax.getCharts = (page, pageSize, search) => {

  let chartUrl = `/team/${team}/projects/published?page=${page}&pageSize=${pageSize}`;
  if (search && search !== '') chartUrl = `/team/${team}/projects/search/published?page=${page}&pageSize=${pageSize}&query=${search}`;

  return ajax.ajax({
    url: chartUrl,
    type: 'get'
  }).then((result) => {
    if (result) {
      return result;
    } else {
      throw 'No Projects';
    }
  });
};

ajax.getSearchCharts = (search, page, pageSize) => {
  return ajax.ajax({
    url: `/team/${team}/projects/published?page=${page}&pageSize=${pageSize}`,
    type: 'get'
  }).then((result) => {
    if (result) {
      return result;
    } else {
      throw 'No Projects';
    }
  });
};

ajax.setLicenseAndTeam = (license,teamId, host) => {
  return ajax.ajax({
    url: `${host}everviz/v1/license`,
    type: 'post',
    data: {
      license_key: license,
      team_id: teamId
    }
  }, true)
  .then((result) => {
    if (result) {
      return result;
    } else {
      throw 'Invalid license';
    }
  });
};

ajax.updateAPILicenseAndTeam = (license,teamId) => {
  team = teamId;
  token = license
}

export default ajax;
